import { Injectable } from '@angular/core';
import { Http, RequestOptions, Headers, } from '@angular/http';
import { DriveServiceProvider } from '../drive-service/drive-service';
import { EncrDecrServiceProvider } from '../encr-decr-service/encr-decr-service';
import { ConfigureServiceProvider } from '../configure-service/configure-service';

declare var jQuery: any;
declare var epcConnect: any;
@Injectable()
export class LoginService {
    isRegistered: boolean = false;
    user_name: string;
    user_pass: string;
    defaultEmailId: string = "it.embryo@gmail.com";
    constructor(private apiService: DriveServiceProvider, private EncrDecrService: EncrDecrServiceProvider, private _http: Http, public configureService: ConfigureServiceProvider) {
    }
    checkForReg() {
        let reg = localStorage.getItem("epcdesk::isReg");
        if (reg && reg === "true") {
            this.isRegistered = true;
        } else {
            this.isRegistered = false;
        }
    }
    isReg() {
        this.checkForReg();
        return this.isRegistered;
    }
    setAsReg(data: any) {
        localStorage.setItem("epcdesk::isReg", "true");
    }
    duoAuthUser(u: string, p: string): Promise<any> {
        let __self = this;
        let c = [u, p];
        this.user_name = u;
        this.user_pass = p;
        let promise = new Promise((resolve, reject) => {
            __self.apiService.duoAuthUser(u, p).then((res) => {
                console.log("Login Result!!");
                console.log(res);
                let d = __self.postAddUser(res, c);
                resolve(d);
            },
                (err) => {
                    console.log(err);
                    reject({ result: "error", msg: err });
                })
        })
        return promise;
    }

    getSecurityToken(u: string, p: string, cbck) {
        let encr_PWD = this.EncrDecrService.set('BETSYENC123$$', p);
        this.user_name = u;
        this.user_pass = encr_PWD;
        let data = Object.assign({}, this.apiService.configApiService.driveApi.loginApiParam.params, { 'userid': this.configureService.getLoginUserID() })
        this.apiService.configApiService.postLoginApi(this.apiService.configApiService.loginScreenApi, this.user_name, this.user_pass, data, (respdata) => {
            console.log('respdata', respdata);
            cbck(respdata);
            localStorage.setItem('token',respdata['_POST_LoginResult'])
            this.configureService.setAccessToken(respdata['_POST_LoginResult'])
        });
    }


    loginuser(u: string, p: string): Promise<any> {
        let __self = this;
        var ecp = this.EncrDecrService.set('BETSYENC123$$', p);
        let c = [u, ecp];
        this.user_name = u;
        this.user_pass = ecp;
        let promise = new Promise((resolve, reject) => {
            __self.apiService.loginUser(u, ecp).then((res) => {
                console.log("Login Result!!");
                console.log(res);
                let d = __self.postAddUser(res, c);
                resolve(d);
            },
                (err) => {
                    console.log(err);
                    reject({ result: "error", msg: err });
                })
        })
        return promise;
    }

    resetpwd(u: string, p: string) {
        var ecp = this.EncrDecrService.set('BETSYENC123$$', p);
        jQuery(epcConnect).trigger("response-password", [ecp])
    }

    processPostAddUser(data) {
        return data["_POST_AddMethodResult"][0];
    }

    postAddUser(res, args): any {
        var _data = res && res !== 'error' && res !== 'FAIL' ? res : null;
        var _msg: any;
        console.info("EPC LOG::EVENT::ADD USER, CHECK RETURN DATA FOR SUCCESS");
        let info = {};
        if (!_data) {
            console.info("EPC LOG::EVENT::ADD USER, FAILED %O", res);
            info = { result: "error", msg: ("Error Registering Your Device!") };
            return info;
        }

        let data = this.processPostAddUser(_data);

        var result = data.Result.toLowerCase();
        var msg = data.Message;
        if (result !== 'success') {
            console.info("EPC LOG::EVENT::ADD USER, FAILED %O", data);
            info = { result: "error", errorcode: 1, msg: (msg ? msg : "Error Registering Your Device!") };
            localStorage.removeItem('epcdesk::isGuest');
            return info;
        }
        console.info("EPC LOG::EVENT::OK::ADD USER, SUCCESS");
        var auid = data.Ref_ID.split("=")[1];
        if (String(auid) === '-1' || data.Ref_ID === "-1") {
            if (msg) {
                _msg = {};
                try {
                    _msg = eval("(" + msg + ")");
                } catch (e) {
                    _msg = { msg: msg };
                }

                if (_msg && _msg['message']) {
                    msg = _msg['message'];
                } else {
                    msg = null;
                }
                info = { result: "error", errorcode: 4, msg: (msg || "Check your credentials and retry!") };
                if (data.Ref_ID === "-1") {
                    if (msg.toLowerCase().indexOf("app is not activated") > -1) {
                        info = { result: "error", errorcode: 2, logindata: { u: this.user_name, p: this.user_pass }, msg: (msg || "Check your credentials and retry!") };
                    }
                }
            }
            return info;
        }
        if (!auid) {
            info = { result: "error", errorcode: 3, msg: ("Please register your device!") };
            return info;
        }

        var eid = args[0];
        var did = args[1];

        var hasTheme = null;
        if (msg) {
            _msg = {};
            try {
                _msg = eval("(" + msg + ")");
            } catch (e) {
                _msg = { msg: msg };
            }

            if (_msg && _msg['theme']) {
                hasTheme = _msg['theme'];
            } else {
                hasTheme = null;
            }

        }
        if (hasTheme) {
        }
        if (true) {
            localStorage.setItem('epcdesk::REG_UID', auid);

            localStorage.setItem('epcdesk::isReg', 'true');
            localStorage.setItem('epcdesk::isActive', 'activated');


        }
        console.info("EPC LOG::EVENT::NO::FETCH APPS LIST FROM SERVER");
        localStorage.setItem('epcdesk::EID', eid);
        localStorage.setItem('epcdesk::PWD', did);
        info = { result: "success", msg: (""), admin: { info: _msg }, auid: auid };
        return info;
    }
    //********* Reset password for staff *******//



}


// WEBPACK FOOTER //
// ./src/providers/login-service/login-service.ts